import { FC } from 'react';
import { Separator, Flex, Text, Icon } from '@/_components';
import { StatusTooltipContentProps } from './StatusTooltipContent.types';
import styles from './StatusTooltipContent.module.css';

// TODO @chris could indicate current step progress within the incomplete list
export const StatusTooltipContent: FC<StatusTooltipContentProps> = ({
  incompleteSections,
  title,
}) => {
  return (
    <Flex isColumn={true} gap={4} className={styles.statusTooltipContent}>
      {title && (
        <>
          <Text type="tiny" fontWeight="bold" color="currentcolor">
            {title}
          </Text>
          <Separator isInverted={true} />
        </>
      )}

      <Text type="tiny" fontWeight="bold" color="currentcolor">
        Incomplete Sections
      </Text>

      <Flex isColumn={true}>
        {incompleteSections?.slice(0, 3).map((sectionName, key) => {
          return (
            <Flex isYCentered={true} gap={2} key={key}>
              <Icon name="dot" size={16} />
              <Text type="tiny" color="currentcolor">
                {sectionName}
              </Text>
            </Flex>
          );
        })}
        {incompleteSections?.length > 3 && (
          <Text type="small" color="currentcolor">
            ...
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
